import script from "./MegaNavColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaNavColumn.vue?vue&type=script&setup=true&lang=js"

import "./MegaNavColumn.vue?vue&type=style&index=0&id=2f92b07c&lang=scss"

const __exports__ = script;

export default __exports__